import React from "react";
import { Tag, Tooltip } from "antd";

export const KYC_STATUS = [
  {
    key: 1,
    name: "Approved",
    color: "green",
    title: "KYC approved successfully",
  },
  { key: 2, name: "Rejected", color: "red", title: "KYC rejected" },
  {
    key: 3,
    name: "Submitted",
    color: "blue",
    title: "KYC submitted, awaiting review",
  },
  { key: 4, name: "RFI", color: "orange", title: "Request for more info" },
  { key: 5, name: "Under Review", color: "purple", title: "KYC under review" },
  {
    key: 6,
    name: "Suspicious",
    color: "pink",
    title: "KYC flagged as suspicious",
  },
  {
    key: 7,
    name: "Pending Revision",
    color: "gold",
    title: "Pending revision from user",
  },
  {
    key: 10,
    name: "Pending (ByPass)",
    color: "cyan",
    title: "Pending bypass approval",
  },
  {
    key: 11,
    name: "Success (ByPass)",
    color: "green",
    title: "Bypass approved",
  },
];

export const KYCStatusTag = ({ statusKey }) => {
  const statusInfo = KYC_STATUS.find((s) => s.key === statusKey);
  if (!statusInfo) return null;

  return (
    <Tooltip title={statusInfo.title}>
      <Tag color={statusInfo.color}>{statusInfo.name}</Tag>
    </Tooltip>
  );
};

export const ID_TYPE = [
  {
    key: "NRIC",
    name: "NRIC",
    color: "blue",
    title: "National Registration Identity Card",
  },
  { key: "ARMY", name: "MyTentera", color: "purple", title: "Army ID" },
  {
    key: "PASSPORT",
    name: "Others",
    color: "cyan",
    title: "Passport / Other ID",
  },
  {
    key: "BRN",
    name: "BRN",
    color: "green",
    title: "Business Registration Number",
  },
];

export const IDTypeTag = ({ idType }) => {
  const info = ID_TYPE.find((i) => i.key === idType);
  if (!info) return null;

  return (
    <Tooltip title={info.title}>
      <Tag color={info.color}>{info.name}</Tag>
    </Tooltip>
  );
};

export const PAYOUT_STATUS = [
  { key: 1, name: "Processing", color: "blue", title: "Payment is processing" },
  {
    key: 2,
    name: "Deposited",
    color: "green",
    title: "Payment successfully deposited",
  },
  { key: 3, name: "Cancelled", color: "red", title: "Payment cancelled" },
  { key: 4, name: "Pending", color: "orange", title: "Payment pending" },
  { key: 5, name: "Rejected", color: "red", title: "Payment rejected" },
  { key: 7, name: "Failed", color: "red", title: "Payment failed" },
];

export const PayoutStatusTag = ({ statusKey }) => {
  const info = PAYOUT_STATUS.find((s) => s.key === statusKey);
  if (!info) return null;

  return (
    <Tooltip title={info.title}>
      <Tag color={info.color}>{info.name}</Tag>
    </Tooltip>
  );
};

export const BENEFICIARY_REQUEST_STATUS = [
  {
    key: "Pending",
    name: "Pending",
    color: "yellow",
    title: "Beneficiary request is sent to Paydibs",
  },
  {
    key: "Approved",
    name: "Approved",
    color: "green",
    title: "Beneficiary request approved",
  },
  {
    key: "Rejected",
    name: "Rejected",
    color: "red",
    title: "Beneficiary request rejected",
  },
  {
    key: "Pending Reject",
    name: "Pending Reject",
    color: "orange",
    title: "Beneficiary request pending rejection",
  },
];

export const BeneficiaryRequestStatusTag = ({ statusKey }) => {
  const info = BENEFICIARY_REQUEST_STATUS.find((s) => s.key === statusKey);
  if (!info) return null;

  return (
    <Tooltip title={info.title}>
      <Tag color={info.color}>{info.name}</Tag>
    </Tooltip>
  );
};